export const REQUEST_EMPLOYER_BENEFIT_BY_DUNS = 'REQUEST_EMPLOYER_BENEFIT_BY_DUNS';
export const RECEIVE_EMPLOYER_BENEFIT_BY_DUNS = 'RECEIVE_EMPLOYER_BENEFIT_BY_DUNS';
export const REQUEST_EMPLOYER_BENEFIT_BY_DUNS_ERROR = 'REQUEST_EMPLOYER_BENEFIT_BY_DUNS_ERROR';
export const CLEAR_EMPLOYER_BENEFIT_BY_DUNS = 'CLEAR_EMPLOYER_BENEFIT_BY_DUNS';
export const CLEAR_EMPLOYER_PRICING_BENEFITS = 'CLEAR_EMPLOYER_PRICING_BENEFITS';

export const REQUEST_EMPLOYER_BENEFITS_BY_NAME = 'REQUEST_EMPLOYER_BENEFITS_BY_NAME';
export const RECEIVE_EMPLOYER_BENEFITS_BY_NAME = 'RECEIVE_EMPLOYER_BENEFITS_BY_NAME';
export const REQUEST_EMPLOYER_BENEFITS_BY_NAME_ERROR = 'REQUEST_EMPLOYER_BENEFITS_BY_NAME_ERROR';
